import { useRouter } from 'next/navigation';
import { AppNextLink } from '@/features/app-next-link';
import DrawerHeader from '@/features/drawer/drawer-header';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import SubMenuExpandablePanel from './sub-menu-expandable-panel';
import { HeaderDrawerName } from '../../constants';
import { Categories, MobileMenuItems } from '../../types';
import { closeMenuOnNavigate } from '../../utils/close-menu-on-navigate';
import Brands from '../mega-menu/brands';
interface Props {
  title: string;
  id: string;
  parentMenuHref: string;
  subMenuChildren?: Categories[];
}
function SubMenuContent({
  title,
  id,
  subMenuChildren,
  parentMenuHref
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const router = useRouter();
  const preTitle = id === MobileMenuItems.Appliancese ? 'همه ' : 'همه محصولات ';
  const handleNavigate = (href: string) => {
    closeMenuOnNavigate();
    router.push(href);
  };
  return <div className={`hide-scrollbar hidden w-full flex-col items-start overflow-hidden rounded-md bg-white pb-18 peer-checked/panel:fixed peer-checked/panel:right-0 peer-checked/panel:top-0 peer-checked/panel:z-10 peer-checked/panel:flex peer-checked/panel:h-screen peer-checked/panel:overflow-auto`} data-sentry-component="SubMenuContent" data-sentry-source-file="sub-menu-content.tsx">
            {/* drawer header */}
            <DrawerHeader hasBackButton={true} htmlFor={HeaderDrawerName} title={title} drawerId={id} data-sentry-element="DrawerHeader" data-sentry-source-file="sub-menu-content.tsx" />

            {/* drawer content */}
            <div className='mt-2 flex w-full flex-col gap-0 bg-white p-2 pt-0 md:mt-0 [&>a]:border-b [&>a]:border-border-gray-medium [&>a]:px-2 [&>a]:py-2.5 [&>a]:text-body-14 [&>a]:text-text-black'>
                {id === MobileMenuItems.Brands ? isMobile && <Brands type='mobile' /> : <>
                        <span onClick={() => handleNavigate(parentMenuHref)} className='border-b border-border-gray-medium px-2 py-2.5 text-body-14 text-text-black'>
                            {preTitle}
                            <AppNextLink href={parentMenuHref} prefetch={false} onClick={closeMenuOnNavigate}>
                                {title}
                            </AppNextLink>
                        </span>

                        {subMenuChildren?.map(({
          categories
        }, index) => categories.map(category => {
          const categoryHref = category.useHrefWithoutParent ? category.href : `${parentMenuHref}${category.href}`;
          return category.links?.length ? <SubMenuExpandablePanel title={category.title} key={`${category.title}${index}`} links={category.links || []} parentLink={categoryHref} /> : <AppNextLink href={categoryHref} prefetch={false} key={`${category.title}${index}`} onClick={closeMenuOnNavigate}>
                                        {category.title}
                                    </AppNextLink>;
        }))}
                    </>}
            </div>
        </div>;
}
export default SubMenuContent;